import React from 'react';
import PropTypes from 'prop-types';
import {
	Card,
	CardImg,
	CardTitle,
} from 'reactstrap';

const propTypes = {

	/**
	 * The Miro board for the card.
	 */
	board: PropTypes.shape({

		/**
		 * The Miro board ID.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The Miro board title.
		 */
		name: PropTypes.string.isRequired,

		/**
		 * The Miro board thumbnail picture.
		 */
		picture: PropTypes.shape({

			/**
			 * The url for the thumbnail picture.
			 */
			imageURL: PropTypes.string.isRequired,

		}),

	}).isRequired,

	/**
	 * The function for the click event for the card.
	 */
	 onSelectBoard: PropTypes.func.isRequired,

};

const MiroBoardCard = ({ board, onSelectBoard }) => {

	const DEFAULT_BOARD_IMAGE =
		'https://d328ser7ogqmui.cloudfront.net/images/miro-empty-board.svg';

	const handleClick = () => {

		onSelectBoard(board);

	};

	return (
		<button
			className="tc-btn-wrapper board-card"
			onClick={handleClick}>
			<Card>
				<div className="board-card-img-container">
					<CardImg
						alt=""
						src={board.picture ? board.picture.imageURL : DEFAULT_BOARD_IMAGE}
						top />
				</div>
				<CardTitle>
					<p className="board-title">
						{board.name}
					</p>
				</CardTitle>
			</Card>
		</button>
	);

};

MiroBoardCard.propTypes = propTypes;

export default MiroBoardCard;
